/*
 * Adversary Force: „Zur Kasse“ während einer Warenkorbänderung (Codex-Zweitprüfung Runde 4, Punkt 4,
 * und Theme Runde 2, Punkt 1; docs/design-manifest.md, Warenkorb: „Checkout während laufender
 * Aktualisierung nicht mit veralteten Werten starten“). Eingebunden von snippets/cart-drawer.liquid
 * und sections/main-cart-footer.liquid, läuft einmal je Seite.
 *
 * Quelle des Zustands ist allein window.AFCartSync aus assets/cart.js mit dem Ereignis af:cart-sync
 * (wartende Mengenänderungen je Artikelschlüssel, nacheinander gesendete /cart/change- und
 * /cart/add-Requests aus cart.js und product-form.js, Erfolg erst nach neu gezeichneten Sections und
 * fertigen Subscribern, Mengen über item.key in der Antwort bestätigt). Kein Abfragen von CSS-Klassen,
 * kein Zeitgeber.
 * - Solange busy gilt, heißen die Kasse-Buttons sichtbar „Warenkorb wird aktualisiert …“, tragen
 *   aria-disabled und aria-busy, die Expressbuttons auf /cart sind inert.
 * - Ein Klick auf „Zur Kasse“ in dieser Zeit wird vorgemerkt (Statusmeldung) und erst beim
 *   Ereignis idle ausgeführt, also wenn alle Änderungen bestätigt sind. Meldet AFCartSync für diesen
 *   Zeitraum failed, wird der Absprung verworfen und verständlich gemeldet.
 */
(function () {
  if (window.afCartCheckout) return;
  window.afCartCheckout = true;

  const BUSY_TEXT = 'Warenkorb wird aktualisiert …';
  const QUEUED_TEXT = 'Warenkorb wird aktualisiert. Danach geht es zur Kasse.';
  const ERROR_TEXT =
    'Der Warenkorb wurde nicht wie gewünscht aktualisiert. Bitte prüfe die Hinweise und tippe dann erneut auf „Zur Kasse“.';
  const FORMS = ['cart', 'CartDrawer-Form'];
  const BUTTONS = '#CartDrawer-Checkout, #checkout';

  let queuedButtonId = '';

  function busyNow() {
    return !!window.AFCartSync && window.AFCartSync.busy;
  }

  function statusFor(button) {
    const container = button && (button.closest('.cart__ctas') || button.parentElement);
    if (!container) return null;
    let status = container.querySelector('[data-af-checkout-status]');
    if (!status) {
      status = document.createElement('p');
      status.className = 'af-checkout-status';
      status.setAttribute('role', 'status');
      status.dataset.afCheckoutStatus = '';
      container.appendChild(status);
    }
    return status;
  }

  function setStatus(text) {
    document.querySelectorAll(BUTTONS).forEach((button) => {
      const status = statusFor(button);
      if (status && status.textContent !== text) status.textContent = text;
    });
  }

  function markButtons(on) {
    document.querySelectorAll(BUTTONS).forEach((button) => {
      if (on) {
        if (button.dataset.afCheckoutLabel === undefined) button.dataset.afCheckoutLabel = button.textContent.trim();
        if (button.textContent.trim() !== BUSY_TEXT) button.textContent = BUSY_TEXT;
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('aria-busy', 'true');
        button.classList.add('af-checkout--busy');
      } else if (button.dataset.afCheckoutLabel !== undefined) {
        button.textContent = button.dataset.afCheckoutLabel;
        delete button.dataset.afCheckoutLabel;
        button.removeAttribute('aria-disabled');
        button.removeAttribute('aria-busy');
        button.classList.remove('af-checkout--busy');
      }
    });
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((express) => {
      express.toggleAttribute('inert', on);
    });
  }

  // Jeder Zustandswechsel kommt nach dem Neuzeichnen der Sections: Buttons immer neu markieren
  document.addEventListener('af:cart-sync', (event) => {
    const detail = event.detail || {};
    if (detail.busy) {
      markButtons(true);
      if (queuedButtonId) setStatus(QUEUED_TEXT);
      return;
    }

    markButtons(false);
    if (!queuedButtonId) return;
    const buttonId = queuedButtonId;
    queuedButtonId = '';
    if (detail.failed) {
      setStatus(ERROR_TEXT);
      return;
    }
    setStatus('');
    const button = document.getElementById(buttonId);
    if (button && !button.disabled) button.click();
  });

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      const button = target.closest(BUTTONS);
      if (!button) return;
      if (busyNow()) {
        event.preventDefault();
        event.stopPropagation();
        queuedButtonId = button.id;
        markButtons(true);
        setStatus(QUEUED_TEXT);
      } else {
        setStatus('');
      }
    },
    true
  );

  // Rückfall für Absenden ohne Klick (Enter im Formular): nie mit laufender Aktualisierung
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || FORMS.indexOf(form.id) === -1) return;
      if (busyNow()) event.preventDefault();
    },
    true
  );

  // Codex Theme Runde 4, Punkt 2: Mit JavaScript laufen alle Mengenänderungen über /cart/change und
  // sind vor dem Absprung bestätigt. Die Mengenfelder im Formular können dagegen veraltet sein
  // (andere Ansicht, Zurück-Cache, zweiter Tab) und würden über updates[] nach Zeilenposition alte
  // Mengen zurückschreiben. Deshalb senden beide Kasse-Formulare keine updates[]; die Kasse übernimmt
  // den Warenkorb des Servers. Ohne JavaScript bleibt Dawns Formular unverändert.
  document.addEventListener(
    'formdata',
    (event) => {
      const form = event.target;
      if (!form || FORMS.indexOf(form.id) === -1 || !event.formData) return;
      event.formData.delete('updates[]');
    },
    true
  );
})();
